import React from 'react';
import { connect } from 'react-redux';
import { IconBtnS } from '../../common';
import RatingItemComponent from './RatingItemComponent';

import { MoreBtn, CommentsWr } from './AdminManagmentCommentsS';
import ConfirmationModal from '../../modals/confirmation';
import { modalsActions, modalsConstants } from '../../../../modules/modals';
import {deleteRatingByAdmin, postRatingByAdmin} from "../../../../modules/review/reviewAction";

const { MODAL_TYPES } = modalsConstants;
const { setModalStateFor } = modalsActions;

const RatingsListComponent = ({
   ratings,
   onLoadMore,
   hasMoreRatings,
   setModalStateFor,
   deleteRatingByAdmin,
   postRatingByAdmin
 }) => (
  <CommentsWr>

    <ConfirmationModal
      confirmationName={MODAL_TYPES.POST_COMMENT_CONFIRMATION}
      onApproved={(id) => postRatingByAdmin(id)}
    />

    <ConfirmationModal
      confirmationName={MODAL_TYPES.DELETE_RATING_CONFIRMATION}
      onApproved={(id) => deleteRatingByAdmin(id)}
    />

    {ratings.map(rating =>
      <RatingItemComponent
        key={rating._id}
        {...{ setModalStateFor, rating }}
      />
    )}

    <MoreBtn aItems="center" justify="center">
      <IconBtnS
        iconName="angle-down"
        size="2x"
        disabled={!hasMoreRatings}
        color={hasMoreRatings ? 'red' : 'gray'}
        onClick={onLoadMore}
      />
    </MoreBtn>
  </CommentsWr>
);

export default connect(null, {
  setModalStateFor,
  deleteRatingByAdmin,
  postRatingByAdmin
})(RatingsListComponent);
